<template>
	<el-dialog
		:title="translations.navigation.media"
		:visible.sync="show"
		:before-close="close"
		:show-close="true"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		width="600px"
	>
		<el-tabs
			v-model="activeTab"
			@tab-click="changeTab"
			type="card"
		>

			<el-tab-pane name="images">
				<span slot="label">
					<i class="el-icon-camera" /> {{ translations.labels.images }}
				</span>
				<MediaTab
					:collection="images"
					:loading="loading"
					:buttonLoading="buttonLoading"
					:pagination="pagination"
					:view="view"
					:inDialog="true"
				/>
			</el-tab-pane>

			<el-tab-pane name="videos">
				<span slot="label">
					<i class="el-icon-video-camera" /> {{ translations.labels.videos }}
				</span>
				<MediaTab
					:collection="videos"
					:loading="loading"
					:buttonLoading="buttonLoading"
					:pagination="pagination"
					:view="view"
					:inDialog="true"
				/>
			</el-tab-pane>

		</el-tabs>
	</el-dialog>
</template>

<script>
import { _getMedia } from '@/services/api/media'
import { EventBus } from '@/services/event-bus'

export default {
	name: 'MediaDialog',
	props: {
		show: Boolean
	},
	components: {
		MediaTab: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Media/Tab')
	},
	data () {
		return {
			activeTab: null,
			buttonLoading: false,
			images: [],
			loading: true,
			pagination: {
				total: null,
				pageSize: 12,
				currentPage: 1
			},
			search: {
				searchField: 'fileName',
				searchValue: '',
				filter: false
			},
			videos: [],
			view: 'grid'
		}
	},
	mounted () {
		EventBus.$on('change-pagination', (data) => this.changePage(data))
		this.activeTab = 'images'
		this.ajaxLoadData()
	},
	destroyed () {
		EventBus.$off('change-pagination')
	},
	methods: {

		ajaxLoadData () {
			const data = {
				searchField: this.search.searchField,
				searchValue: this.search.searchValue,
				currentPage: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				sortBy: 'createdAt',
				sortCriteria: 'desc'
			}
			_getMedia (data, this.activeTab)
				.then(response => {
					if (this.pagination.currentPage === 1) {
						this[this.activeTab] = []
					}
					this[this.activeTab] = [...this[this.activeTab], ...response.responseList]
					this.pagination = {
						total: response.total,
						pageSize: response.pageSize,
						currentPage: response.currentPage
					}
					setTimeout (() => {
						this.loading = false
						this.buttonLoading = false
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.status
					setTimeout (() => {
						this.loading = false
						this.displayMessage(this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
					}, 200)
				})
		},

		changeTab () {
			this.loading = true
			this.buttonLoading = false
			this.pagination.currentPage = 1
			this.ajaxLoadData()
		},
		close () {
			EventBus.$emit('close-library')
		},
		changePage (page) {
			this.buttonLoading = true
			this.pagination.currentPage = page
			this.ajaxLoadData()
		}

	}
}
</script>
